"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configure = exports.resource = exports.fetchBlob = exports.fetchText = exports.fetchJson = exports.fetchResponse = exports.originalFetch = exports.HTTPMethod = exports.HTTPAuthenticationScheme = exports.HTTPContentType = exports.FetchError = void 0;
/**
 * @file Provides fetch functions.
 */
const defaults_1 = require("./defaults");
Object.defineProperty(exports, "configure", {
  enumerable: true,
  get: function () {
    return defaults_1.setDefaultOptions;
  }
});
const fetch_error_1 = __importDefault(require("./fetch_error"));
exports.FetchError = fetch_error_1.default;
const prepare_fetch_arguments_1 = require("./prepare_fetch_arguments");
const types_1 = require("./types");
Object.defineProperty(exports, "HTTPAuthenticationScheme", {
  enumerable: true,
  get: function () {
    return types_1.HTTPAuthenticationScheme;
  }
});
Object.defineProperty(exports, "HTTPContentType", {
  enumerable: true,
  get: function () {
    return types_1.HTTPContentType;
  }
});
Object.defineProperty(exports, "HTTPMethod", {
  enumerable: true,
  get: function () {
    return types_1.HTTPMethod;
  }
});
async function originalFetch(url) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return fetch(url, options);
}
exports.originalFetch = originalFetch;
async function fetchResponse(url) {
  for (var _len = arguments.length, options = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    options[_key - 1] = arguments[_key];
  }
  const [fetchUrl, fetchOptions] = (0, prepare_fetch_arguments_1.prepareFetchArguments)(url, options);
  let response;
  try {
    response = await originalFetch(fetchUrl, fetchOptions);
    if (response && response.status >= 100 && response.status <= 399) {
      return response;
    }
  } catch (error) {
    const e = error;
    throw new fetch_error_1.default(0, e.message, undefined, error);
  }
  const body = await response.text();
  throw new fetch_error_1.default(response.status, body, response);
}
exports.fetchResponse = fetchResponse;
async function fetchJson(url) {
  for (var _len2 = arguments.length, options = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    options[_key2 - 1] = arguments[_key2];
  }
  const response = await fetchResponse(url, ...(0, prepare_fetch_arguments_1.prepareJsonFetchArguments)(options));
  const json = await response.json();
  return json;
}
exports.fetchJson = fetchJson;
async function fetchText(url) {
  for (var _len3 = arguments.length, options = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    options[_key3 - 1] = arguments[_key3];
  }
  const response = await fetchResponse(url, ...options);
  return response.text();
}
exports.fetchText = fetchText;
async function fetchBlob(url) {
  for (var _len4 = arguments.length, options = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    options[_key4 - 1] = arguments[_key4];
  }
  const response = await fetchResponse(url, ...options);
  return response.blob();
}
exports.fetchBlob = fetchBlob;
function resource(baseUrlWithoutTrailingSlash) {
  for (var _len5 = arguments.length, baseOptions = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    baseOptions[_key5 - 1] = arguments[_key5];
  }
  function localFetch(relativePath) {
    const fullUrl = relativePath === '' ? baseUrlWithoutTrailingSlash : [baseUrlWithoutTrailingSlash, relativePath].join('/');
    for (var _len6 = arguments.length, options = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
      options[_key6 - 1] = arguments[_key6];
    }
    return fetchJson(fullUrl, ...baseOptions, ...options);
  }
  const fetchResource = {
    index(query) {
      for (var _len7 = arguments.length, options = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        options[_key7 - 1] = arguments[_key7];
      }
      return localFetch('', ...options, {
        method: types_1.HTTPMethod.get,
        query
      });
    },
    show(id) {
      for (var _len8 = arguments.length, options = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
        options[_key8 - 1] = arguments[_key8];
      }
      return localFetch(id.toString(), ...options, {
        method: types_1.HTTPMethod.get
      });
    },
    create(jsonData) {
      for (var _len9 = arguments.length, options = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
        options[_key9 - 1] = arguments[_key9];
      }
      return localFetch('', ...options, {
        method: types_1.HTTPMethod.post,
        jsonData
      });
    },
    update(jsonData) {
      for (var _len10 = arguments.length, options = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
        options[_key10 - 1] = arguments[_key10];
      }
      return localFetch(jsonData.id.toString(), ...options, {
        method: types_1.HTTPMethod.put,
        jsonData
      });
    },
    destroy(id) {
      for (var _len11 = arguments.length, options = new Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
        options[_key11 - 1] = arguments[_key11];
      }
      return localFetch(id.toString(), ...options, {
        method: types_1.HTTPMethod.delete
      });
    },
    get(relativePath) {
      for (var _len12 = arguments.length, options = new Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++) {
        options[_key12 - 1] = arguments[_key12];
      }
      return localFetch(relativePath, ...options, {
        method: types_1.HTTPMethod.get
      });
    },
    post(relativePath, jsonData) {
      for (var _len13 = arguments.length, options = new Array(_len13 > 2 ? _len13 - 2 : 0), _key13 = 2; _key13 < _len13; _key13++) {
        options[_key13 - 2] = arguments[_key13];
      }
      return localFetch(relativePath, ...options, {
        method: types_1.HTTPMethod.post,
        jsonData
      });
    },
    put(relativePath, jsonData) {
      for (var _len14 = arguments.length, options = new Array(_len14 > 2 ? _len14 - 2 : 0), _key14 = 2; _key14 < _len14; _key14++) {
        options[_key14 - 2] = arguments[_key14];
      }
      return localFetch(relativePath, ...options, {
        method: types_1.HTTPMethod.put,
        jsonData
      });
    },
    delete(relativePath) {
      for (var _len15 = arguments.length, options = new Array(_len15 > 1 ? _len15 - 1 : 0), _key15 = 1; _key15 < _len15; _key15++) {
        options[_key15 - 1] = arguments[_key15];
      }
      return localFetch(relativePath, ...options, {
        method: types_1.HTTPMethod.delete
      });
    },
    fetch(relativePath) {
      for (var _len16 = arguments.length, options = new Array(_len16 > 1 ? _len16 - 1 : 0), _key16 = 1; _key16 < _len16; _key16++) {
        options[_key16 - 1] = arguments[_key16];
      }
      return localFetch(relativePath, ...options);
    }
  };
  return fetchResource;
}
exports.resource = resource;